'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (className) {

  return function (element, modifier) {
    var el = element ? '-' + element : '';
    var mod = modifier ? '--' + modifier : '';

    return '' + className + el + mod;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-date-picker/lib/bemFactory.js
// module id = 815
// module chunks = 0